"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledStickyDrawer = exports.DrawerPromotionalArea = exports.DrawerBodyContent = exports.DrawerBody = exports.Dialog = exports.Content = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _stickyDrawer = require("../../fuse-sticky-drawer/src/sticky-drawer");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var sidesEnum = Object.freeze({
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
});
var getCssTranslate = function getCssTranslate() {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, sidesEnum.left, {
    opened: 'translateX(100%)'
  }), sidesEnum.right, {
    opened: 'translateX(-100%)'
  }), sidesEnum.top, {
    opened: 'translateY(100%)'
  }), sidesEnum.bottom, {
    opened: 'translateY(-100%)'
  });
};
var animationDelay = '200ms';
var Dialog = exports.Dialog = _styledComponents["default"].div.attrs({
  className: 'fuse-drawer'
}).withConfig({
  displayName: "styled-drawer-dialogue__Dialog",
  componentId: "sc-ftj9md-0"
})(["", ""], function (props) {
  var cssTranslate = getCssTranslate()[props.slidePosition];
  var translate = props.open ? 'translateX(0%)' : cssTranslate.opened;
  return "\n\t\t\tbackground-color: var(--color-functional-panelLight);\n\t\t\tdisplay: block;\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tbottom: 0;\n\t\t\ttransition: ".concat(animationDelay, ";\n\t\t\ttransform: ").concat(translate, ";\n\t\t\twill-change: transform, visibility, height;\n\t\t\tvisibility: ").concat(props.open ? 'visible' : 'hidden', ";\n\t\t\twidth: 100%;\n\t\t\tz-index: ").concat(props.zIndex, ";\n\t\t\t");
});
var Content = exports.Content = _styledComponents["default"].div.attrs({
  className: 'fuse-drawer__content'
}).withConfig({
  displayName: "styled-drawer-dialogue__Content",
  componentId: "sc-ftj9md-1"
})(["display:flex;flex-flow:column nowrap;height:100%;position:relative;width:100%;transition:", ";will-change:transform,visibility,height;visibility:", ";"], animationDelay, function (props) {
  return props.open ? 'visible' : 'hidden';
});
var DrawerBody = exports.DrawerBody = _styledComponents["default"].div.attrs({
  className: 'fuse-drawer__body'
}).withConfig({
  displayName: "styled-drawer-dialogue__DrawerBody",
  componentId: "sc-ftj9md-2"
})(["", ";"], function (_ref2) {
  var hasPromotionalArea = _ref2.hasPromotionalArea,
    stickyDrawerHeight = _ref2.stickyDrawerHeight;
  return "\n\t\t\tflex: 1 1 100%;\n\t\t\tpadding-top: ".concat(hasPromotionalArea ? "0px" : "var(--spacing-global-space7)", ";\n\t\t\tmargin: 0 0 ").concat(stickyDrawerHeight, "px 0;\n\t\t\toverflow: auto;\n\t\t\twidth: 100%\n\t\t");
});
var StyledStickyDrawer = exports.StyledStickyDrawer = (0, _styledComponents["default"])(_stickyDrawer.StickyDrawer).attrs({
  className: 'fuse-drawer__sticky-drawer',
  'data-testid': 'fuse-drawer__sticky-drawer'
}).withConfig({
  displayName: "styled-drawer-dialogue__StyledStickyDrawer",
  componentId: "sc-ftj9md-3"
})(["position:absolute;"]);
var DrawerPromotionalArea = exports.DrawerPromotionalArea = _styledComponents["default"].div.attrs({
  className: 'fuse-drawer__body-promotional-area'
}).withConfig({
  displayName: "styled-drawer-dialogue__DrawerPromotionalArea",
  componentId: "sc-ftj9md-4"
})(["width:100%;"]);
var DrawerBodyContent = exports.DrawerBodyContent = _styledComponents["default"].div.attrs({
  className: 'fuse-drawer__body-content'
}).withConfig({
  displayName: "styled-drawer-dialogue__DrawerBodyContent",
  componentId: "sc-ftj9md-5"
})(["", ";"], function (_ref3) {
  var hasPromotionalArea = _ref3.hasPromotionalArea;
  return "\n\t\t\tpadding: var(--spacing-global-space7) ".concat(_grid.gridConfig.xxs.margin, " ").concat(_grid.gridConfig.xxs.margin, " ").concat(_grid.gridConfig.xxs.margin, ";\n\t\t\t").concat(hasPromotionalArea ? "" : "padding-top: 0px;", "\n\t\t\n\t\t\t@media only screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\tpadding: var(--spacing-global-space7) ").concat(_grid.gridConfig.m.margin, " ").concat(_grid.gridConfig.m.margin, " ").concat(_grid.gridConfig.m.margin, ";\n\t\t\t\t").concat(hasPromotionalArea ? "" : "padding-top: 0px;", "\n\n\t\t\t}\n\t\t");
});